/* Case Studio -- full-screen preview.
   A look at the finished product with none of the editing furniture: no
   handles, no rail, no hints. It rebuilds the same <img> + <canvas> + transform
   stack the editor uses, at whatever size the screen allows, so the perspective
   and the masking come out identical without the engine knowing about it.

   It carries its own zoom. That is not only a convenience: pinching the page
   over a canvas under a perspective transform makes the browser re-rasterise
   it at the zoomed size, and on a phone that allocation is what was killing
   the tab. The gesture is taken here instead, and how far it can go is worked
   out from how many pixels the result would actually cost. */
(function(){
"use strict";

var root = document.getElementById("case-studio");
if (!root) return;
var wrap  = root.querySelector("#stageWrap");
var inner = root.querySelector("#deviceInner");
var mock  = root.querySelector("#mock");
var art   = root.querySelector("#art");
if (!wrap || !inner || !mock || !art) return;

var TAG = document.currentScript || document.querySelector("script[data-cs-peek-label]");
var LABEL = (TAG && TAG.getAttribute("data-cs-peek-label")) || "Preview";

var COARSE = !!(window.matchMedia && window.matchMedia("(pointer:coarse)").matches);
/* How large the composited picture is allowed to get, in device pixels. */
var BUDGET = COARSE ? 20e6 : 45e6;

var css = document.createElement("style");
css.textContent =
  ".cs-peek-ov{touch-action:none;overscroll-behavior:contain}" +
  ".cs-peek-dev{will-change:auto}" +
  ".cs-peek-dev.is-zoomed{filter:none}" +
  ".cs-peek-zoom{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);" +
    "display:flex;align-items:center;gap:2px;padding:3px;border-radius:999px;" +
    "background:rgba(16,16,18,.66);box-shadow:0 2px 12px rgba(0,0,0,.28);" +
    "-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}" +
  ".cs-peek-zoom button{min-width:34px;height:34px;padding:0 9px;border:0;border-radius:999px;" +
    "background:transparent;color:#fff;font-family:inherit;font-size:15px;font-weight:600;" +
    "line-height:1;cursor:pointer;-webkit-tap-highlight-color:transparent}" +
  ".cs-peek-zoom button:hover:not(:disabled){background:rgba(255,255,255,.16)}" +
  ".cs-peek-zoom button:disabled{opacity:.32;cursor:default}" +
  ".cs-peek-zoom .pct{min-width:50px;font-size:12px;font-variant-numeric:tabular-nums}" +
  "@media screen and (max-width:900px){.cs-peek-zoom{bottom:14px}}";
document.head.appendChild(css);

var btn = document.createElement("button");
btn.type = "button";
btn.className = "cs-peek";
btn.setAttribute("aria-label", LABEL + " full screen");
btn.innerHTML =
  '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M9 4H4v5M15 4h5v5M15 20h5v-5M9 20H4v-5" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg><span>' + LABEL + '</span>';
wrap.appendChild(btn);

var ov = null, dev = null, box = null, bar = null, pct = null;
var onKey = null, fitW = 0, fitH = 0;
var z = 1, px = 0, py = 0;
var pointers = {}, pinch = null, pan = null;

function clamp(v, a, b){ return v < a ? a : (v > b ? b : v); }

/* Past this the browser is being asked for a texture it will refuse to make. */
function zMax(){
  if (!fitW || !fitH) return 2;
  var dpr = Math.min(window.devicePixelRatio || 1, 3);
  var at1 = fitW * dpr * fitH * dpr;
  return clamp(Math.sqrt(BUDGET / at1), 1.5, 3.5);
}

function size(){
  if (!ov) return;
  var W = parseFloat(inner.style.width)  || 1080;
  var H = parseFloat(inner.style.height) || 1350;
  var k = Math.min((ov.clientWidth - 40) / W, (ov.clientHeight - 104) / H);
  if (!(k > 0)) k = 0.1;
  fitW = W * k; fitH = H * k;
  dev.style.width  = fitW + "px";
  dev.style.height = fitH + "px";
  box.style.width  = W + "px";
  box.style.height = H + "px";
  box.style.transform = "scale(" + k + ")";
  apply();
}

function apply(){
  var mx = Math.max(0, (fitW*z - ov.clientWidth)/2 + 24);
  var my = Math.max(0, (fitH*z - ov.clientHeight)/2 + 24);
  px = clamp(px, -mx, mx);
  py = clamp(py, -my, my);
  dev.style.transform = "translate(" + px + "px," + py + "px) scale(" + z + ")";
  dev.classList.toggle("is-zoomed", z > 1.01);
  if (pct) pct.textContent = Math.round(z*100) + "%";
  if (bar){
    bar.querySelector(".zin").disabled  = z >= zMax() - 1e-3;
    bar.querySelector(".zout").disabled = z <= 1 + 1e-3;
  }
}

/* Zoom about a point on screen, so what is under the fingers stays put. */
function setZ(want, cx, cy){
  var next = clamp(want, 1, zMax());
  if (Math.abs(next - z) < 1e-4) return;
  if (cx != null){
    var r = ov.getBoundingClientRect();
    var ox = cx - r.left - r.width/2 - px;
    var oy = cy - r.top - r.height/2 - py;
    var f = next / z;
    px -= ox * (f - 1);
    py -= oy * (f - 1);
  }
  z = next;
  if (z <= 1.001){ px = 0; py = 0; }
  apply();
}

function step(dir){
  var r = ov.getBoundingClientRect();
  setZ(z * (dir > 0 ? 1.4 : 1/1.4), r.left + r.width/2, r.top + r.height/2);
}

function livePts(){
  var out = [], k;
  for (k in pointers) out.push(pointers[k]);
  return out;
}
function mid(a, b){ return { x:(a.x+b.x)/2, y:(a.y+b.y)/2 }; }
function dist(a, b){ return Math.hypot(a.x-b.x, a.y-b.y) || 1; }

function down(ev){
  if (ev.target.closest && ev.target.closest(".cs-peek-zoom, .cs-peek-x")) return;
  pointers[ev.pointerId] = { x:ev.clientX, y:ev.clientY };
  var ps = livePts();
  if (ps.length === 2){
    pan = null;
    pinch = { d:dist(ps[0], ps[1]), z:z, px:px, py:py, m:mid(ps[0], ps[1]) };
  } else if (ps.length === 1 && z > 1.01){
    pan = { sx:ev.clientX, sy:ev.clientY, px:px, py:py, moved:0 };
  }
}
function move(ev){
  if (!pointers[ev.pointerId]) return;
  pointers[ev.pointerId] = { x:ev.clientX, y:ev.clientY };
  if (pinch){
    var ps = livePts();
    if (ps.length < 2) return;
    if (ev.cancelable) ev.preventDefault();
    var m = mid(ps[0], ps[1]);
    px = pinch.px + (m.x - pinch.m.x);
    py = pinch.py + (m.y - pinch.m.y);
    setZ(pinch.z * (dist(ps[0], ps[1]) / pinch.d), m.x, m.y);
    return;
  }
  if (pan){
    if (ev.cancelable) ev.preventDefault();
    px = pan.px + (ev.clientX - pan.sx);
    py = pan.py + (ev.clientY - pan.sy);
    pan.moved = Math.max(pan.moved, Math.hypot(ev.clientX - pan.sx, ev.clientY - pan.sy));
    apply();
  }
}
function up(ev){
  var wasTap = pan && pan.moved < 5;
  delete pointers[ev.pointerId];
  if (livePts().length < 2) pinch = null;
  if (!livePts().length) pan = null;
  return wasTap;
}

function shut(){
  if (!ov) return;
  window.removeEventListener("resize", size);
  document.removeEventListener("keydown", onKey);
  if (ov.parentNode) ov.parentNode.removeChild(ov);
  ov = null; dev = null; box = null; bar = null; pct = null;
  pointers = {}; pinch = null; pan = null;
  z = 1; px = 0; py = 0;
  document.documentElement.style.overflow = "";
}

function open(){
  shut();

  ov = document.createElement("div");
  ov.className = "cs-peek-ov";
  ov.setAttribute("data-scene", wrap.getAttribute("data-scene") || "light");

  dev = document.createElement("div"); dev.className = "cs-peek-dev";
  box = document.createElement("div"); box.className = "cs-peek-inner";

  var im = document.createElement("img");
  im.src = mock.currentSrc || mock.src;
  im.alt = ""; im.draggable = false;

  /* The editor's canvas already holds the finished, masked artwork -- copy the
     bitmap rather than re-running the engine, and carry its transform over. */
  var cv = document.createElement("canvas");
  cv.width = art.width; cv.height = art.height;
  try { cv.getContext("2d").drawImage(art, 0, 0); } catch(e){}
  cv.style.transformOrigin = "0 0";
  cv.style.transform = art.style.transform || "";

  box.appendChild(im);
  box.appendChild(cv);
  dev.appendChild(box);
  ov.appendChild(dev);

  var x = document.createElement("button");
  x.type = "button";
  x.className = "cs-peek-x";
  x.textContent = "Close";
  x.addEventListener("click", shut);
  ov.appendChild(x);

  bar = document.createElement("div");
  bar.className = "cs-peek-zoom";
  bar.innerHTML =
    '<button type="button" class="zout" aria-label="Zoom out">−</button>' +
    '<button type="button" class="pct" aria-label="Reset zoom">100%</button>' +
    '<button type="button" class="zin" aria-label="Zoom in">+</button>';
  pct = bar.querySelector(".pct");
  bar.querySelector(".zout").addEventListener("click", function(){ step(-1); });
  bar.querySelector(".zin").addEventListener("click", function(){ step(1); });
  pct.addEventListener("click", function(){ z = 1; px = 0; py = 0; apply(); });
  ov.appendChild(bar);

  document.body.appendChild(ov);
  document.documentElement.style.overflow = "hidden";

  /* Safari fires its own pinch on top of the pointer events; left alone it
     zooms the page and re-rasterises everything underneath. */
  ["gesturestart","gesturechange","gestureend"].forEach(function(t){
    ov.addEventListener(t, function(e){ e.preventDefault(); }, { passive:false });
  });
  ov.addEventListener("pointerdown", down);
  ov.addEventListener("pointermove", move, { passive:false });
  ov.addEventListener("pointerup", function(e){
    var tap = up(e);
    if (tap && (e.target === ov || e.target === dev)) shut();
  });
  ov.addEventListener("pointercancel", up);
  ov.addEventListener("wheel", function(e){
    e.preventDefault();
    setZ(z * (e.deltaY < 0 ? 1.12 : 1/1.12), e.clientX, e.clientY);
  }, { passive:false });
  ov.addEventListener("dblclick", function(e){
    if (z > 1.01){ z = 1; px = 0; py = 0; apply(); }
    else setZ(zMax(), e.clientX, e.clientY);
  });

  size();
  window.addEventListener("resize", size);
  onKey = function(e){
    if (e.key === "Escape" || e.key === "Esc") shut();
    else if (e.key === "+" || e.key === "=") step(1);
    else if (e.key === "-" || e.key === "_") step(-1);
    else if (e.key === "0"){ z = 1; px = 0; py = 0; apply(); }
  };
  document.addEventListener("keydown", onKey);
  /* A plain click on the backdrop still closes it, for a mouse. */
  ov.addEventListener("click", function(e){
    if (z <= 1.01 && (e.target === ov || e.target === dev)) shut();
  });
}

btn.addEventListener("click", open);

})();
